import styled from 'styled-components';

const StyledFile = styled.div`
  padding: 1em 1em 0 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

export default StyledFile;
